// Keep the walkthrough beside its subject, not on top of the controls it explains.
export function getGuidePosition(rect, viewportWidth, viewportHeight, naturalHeight) {
  const margin = 16;
  const gap = 16;
  const width = Math.min(380, viewportWidth - margin * 2);
  const maxHeight = viewportHeight - margin * 2;
  const height = Math.min(naturalHeight, maxHeight);
  const clamp = (value, min, max) => Math.max(min, Math.min(value, max));
  if (!rect) return { left: (viewportWidth - width) / 2, top: margin, maxHeight };
  const right = rect.left + rect.width;
  const left = clamp(rect.left, margin, viewportWidth - width - margin);
  const top = clamp(rect.top, margin, viewportHeight - height - margin);
  const below = viewportHeight - margin - rect.bottom - gap;
  const above = rect.top - gap - margin;
  if (below >= height) return { left, top: rect.bottom + gap, maxHeight };
  if (above >= height) return { left, top: rect.top - gap - height, maxHeight };
  if (viewportWidth - margin - right - gap >= width) return { left: right + gap, top, maxHeight };
  if (rect.left - gap - margin >= width) return { left: rect.left - gap - width, top, maxHeight };
  // Short screens: scroll the explanation while keeping navigation visible.
  if (Math.max(above, below) >= 160) {
    return above >= below
      ? { left, top: margin, maxHeight: above }
      : { left, top: rect.bottom + gap, maxHeight: below };
  }
  // A viewport-sized subject has no outside space; keep the guide reachable.
  return { left, top: viewportHeight - height - margin, maxHeight };
}
